import styled from 'astroturf/react';
import Button from 'src/components/Button';
import Svg from 'src/components/Svg';

const ActionButton = styled(Button)`
  &.disabled {
    background-color: var(--ph-gray-50) !important;
    color: var(--ph-gray-300);
    cursor: not-allowed;
    pointer-events: none;

    &:focus {
      box-shadow: none !important;
    }
  }
`;

const ActionButtonsWrapper = styled('div')`
  display: flex;
  justify-content: space-evenly;
  margin-top: 20px;
  user-select: none;
`;

const FieldBox = styled('div')`
  margin-top: 20px;
`;

const FieldBoxContentWrapper = styled('div')`
  padding: 10px;
  border: 2px solid var(--ph-gray-500);
  border-top: none;
  border-radius: 0 0 var(--ph-border-radius-sm) var(--ph-border-radius-sm);
  font-style: italic;

  &.fullBorder {
    border: 2px solid var(--ph-gray-500);
    border-top: 2px solid var(--ph-gray-500);
    border-radius: var(--ph-border-radius-sm);
  }
`;

const FieldBoxHeaderWrapper = styled('div')`
  padding: 10px;
  font-weight: 500;

  &.withBorder {
    border: 2px solid var(--ph-gray-500);
    border-radius: var(--ph-border-radius-sm) var(--ph-border-radius-sm) 0 0;
  }
`;

const HeaderBlock = styled('div')`
  display: flex;
  align-items: center;
  user-select: none;
`;

const HeaderButton = styled(Button)`
  min-width: 0;

  &.disabled {
    background-color: var(--ph-gray-50) !important;
    color: var(--ph-gray-300);
    cursor: not-allowed;
    pointer-events: none;

    &:focus {
      box-shadow: none !important;
    }
  }
`;

const HeaderButtonsWrapper = styled('div')`
  margin-left: 20px;
`;

const HeaderText = styled('span')`
  font-size: var(--ph-heading-four);
  font-stretch: normal;
  font-style: normal;
  color: var(--black);
`;

const Icon = styled(Svg)`
  width: 45px;
  height: 45px;
`;

const InvisibleInput = styled('input')`
  border: none;

  &:focus {
    border: none;
    outline: none;
  }

`;

const LinkButton = styled(Button)`
  border-bottom: 0 !important;
`;

const NoTyposText = styled('h3')`
  margin: 10px 0 0;
  font-size: var(--ph-heading-five);
  text-align: center;

`;

const NoTyposWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 20px;

  &::selection {
    background: var(--ph-orange-25);
  }
`;

const SpellCheckPopupWrapper = styled('div')`
  * {
    &::selection {
      background: var(--ph-orange-25);
    }
  }
`;

const SubmitButton = styled(Button)`
  padding: 13px 41px;
  min-width: 0;
`;

const Text = styled('div')`
  font-size: var(--ph-text-sm);
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.44;
  letter-spacing: normal;
  color: var(--black);
  margin: 10px 0;
`;

const Title = styled('span')`
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: var(--ph-heading-two);

  &::selection {
    background: var(--ph-orange-25);
  }
`;

const UnknownWordHeading = styled('h3')`
  margin: 20px 0;
  font-size: var(--ph-heading-five);
  text-align: center;

  mark {
    color: var(--ph-red-500);
    background-color: transparent;
  }
`;

export default {
  ActionButton,
  ActionButtonsWrapper,
  FieldBox,
  FieldBoxContentWrapper,
  FieldBoxHeaderWrapper,
  HeaderBlock,
  HeaderButton,
  HeaderButtonsWrapper,
  HeaderText,
  Icon,
  InvisibleInput,
  LinkButton,
  NoTyposText,
  NoTyposWrapper,
  SpellCheckPopupWrapper,
  SubmitButton,
  Text,
  Title,
  UnknownWordHeading,
};
